import { UnversalModal } from '../universal-modal/universal-modal';

const triggerSelector = '[data-organisation-search-modal-url]';

const showUnavailableMessage = () => {
    const message = 'This record is no longer available';

    if (window.toastr) {
        window.toastr.error(message);
    } else {
        console.error(message);
    }
};

const organisationSearchEntityModal = {
    init() {
        let activeRequest = null;

        const restoreTrigger = (trigger) => {
            trigger.disabled = false;
            trigger.removeAttribute('aria-busy');
            trigger.removeAttribute('aria-disabled');
            trigger.classList.remove('is-loading');
        };

        const openTarget = (target, trigger) => {
            const customerId = Number.parseInt(target.customer_id, 10);

            if (!Number.isInteger(customerId) || !target.step) {
                restoreTrigger(trigger);
                showUnavailableMessage();
                return;
            }

            const modal = new UnversalModal(customerId, 'form-container-s', { syncUrl: false });
            const parentId = target.parent_id == null ? null : Number.parseInt(target.parent_id, 10);
            const entityId = target.entity_id == null ? null : Number.parseInt(target.entity_id, 10);
            const localIds = {
                parentLocalId: target.parent_local_id == null
                    ? null
                    : Number.parseInt(target.parent_local_id, 10),
                entityLocalId: target.entity_local_id == null
                    ? null
                    : Number.parseInt(target.entity_local_id, 10),
            };

            $(document)
                .off('hidden.bs.modal.organisationSearchEntity', '#u-customer-modal')
                .one('hidden.bs.modal.organisationSearchEntity', '#u-customer-modal', () => {
                    restoreTrigger(trigger);
                    const focusTarget = trigger.isConnected && trigger.getClientRects().length
                        ? trigger
                        : document.getElementById('global-search-input');
                    if (focusTarget) {
                        focusTarget.focus({ preventScroll: true });
                    }
                });

            $('#u-customer-modal').remove();
            modal.openModal(
                target.step,
                target.internal_step || null,
                Number.isInteger(parentId) ? parentId : null,
                Number.isInteger(entityId) ? entityId : null,
                localIds,
                {
                    onError: () => {
                        restoreTrigger(trigger);
                        showUnavailableMessage();
                    },
                },
            );
        };

        const activate = async (event) => {
            const trigger = event.target.closest(triggerSelector);

            if (!trigger || trigger.disabled) {
                return;
            }

            event.preventDefault();
            event.stopPropagation();

            trigger.disabled = true;
            trigger.setAttribute('aria-busy', 'true');
            trigger.setAttribute('aria-disabled', 'true');
            trigger.classList.add('is-loading');
            document.dispatchEvent(new CustomEvent('organisation-search:close'));

            if (activeRequest) {
                activeRequest.abort();
            }

            const request = new AbortController();
            activeRequest = request;

            try {
                const response = await fetch(trigger.dataset.organisationSearchModalUrl, {
                    credentials: 'same-origin',
                    headers: {
                        Accept: 'application/json',
                        'X-Requested-With': 'XMLHttpRequest',
                    },
                    signal: request.signal,
                });

                if (!response.ok) {
                    throw new Error(`Search modal request failed with ${response.status}`);
                }

                const payload = await response.json();
                openTarget(payload.target || {}, trigger);
            } catch (error) {
                restoreTrigger(trigger);
                if (error.name !== 'AbortError') {
                    showUnavailableMessage();
                }
            } finally {
                if (activeRequest === request) {
                    activeRequest = null;
                }
            }
        };

        document.addEventListener('click', activate);
        document.addEventListener('auxclick', (event) => {
            if (event.button === 1) {
                activate(event);
            }
        });
        document.addEventListener('keydown', (event) => {
            if (!['Enter', ' '].includes(event.key)) {
                return;
            }

            const trigger = event.target.closest(triggerSelector);
            if (trigger && trigger.matches('tr[role="button"]')) {
                activate(event);
            }
        });
    },
};

export default organisationSearchEntityModal;
